var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9805 7.51562C14.9805 7.51562 15.4805 8.01562 15.9805 9.01562C15.9805 9.01562 17.5687 6.51562 18.9805 6.01562",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99485 2.5214C7.49638 2.41562 5.56612 2.70344 5.56612 2.70344C4.34727 2.79059 2.01146 3.47391 2.01148 7.4646C2.0115 11.4214 1.98564 16.2994 2.01148 18.244C2.01148 19.4321 2.7471 22.2034 5.29326 22.3519C8.3881 22.5325 13.9627 22.5709 16.5204 22.3519C17.2051 22.3133 19.4846 21.7758 19.7731 19.2957C20.072 16.7264 20.0125 14.9408 20.0125 14.5158",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 7.51562C21.9998 10.277 19.7591 12.5157 16.995 12.5157C14.2309 12.5157 11.9902 10.277 11.9902 7.51562C11.9902 4.7542 14.2309 2.51562 16.995 2.51562C19.7591 2.51562 21.9998 4.7542 21.9998 7.51562Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98047 13.5156H10.9804",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98047 17.5156H14.9804",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIcon);
export default __webpack_public_path__ + "static/media/applicationIcon.3b3bc39df9ea9280850a3175c70c7c4c.svg";
export { ForwardRef as ReactComponent };